/** Shared contact details for QicApp Technologies */
export const contactInfo = {
  companyName: 'Aeviot Office',
  buildingName: 'SVH 83 Metro Street',
  addressLines: [
    '1422-14th Floor, 83 Metro Street',
    'Sector 83 Gurgaon, HR 122004',
    'India',
  ],
  mapAddress: 'Sector 83, Gurugram, Haryana 122012, India',
  email: 'info@aeviot.com',
  phone: '+91 124-4147306',
  phoneTel: '+911244147306',
  businessHours: [
    { days: 'Mon – Fri', hours: '9:00 AM – 6:00 PM' },
    { days: 'Saturday', hours: '10:00 AM – 4:00 PM' },
    { days: 'Sunday', hours: 'Closed' },
  ],
  timezone: 'IST',
  mapsCid: '8366362030524202303',
  mapsOpenUrl:
    'https://www.google.com/maps?cid=8366362030524202303',
  mapsEmbedUrl:
    'https://www.google.com/maps?cid=8366362030524202303&output=embed',
} as const;
